module.exports = __webpack_public_path__ + "static/media/cp82.4868187a.jpg";